/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import {
	clear,

	clearCustomers,
	addCustomer,
	removeCustomer,

	clearOwners,
	addOwner,
	removeOwner,

	clearEditors,
	addEditor,
	removeEditor,

	clearLineNames,
	addLineName,
	removeLineName,

	clearSurveyTypes,
	addSurveyType,
	removeSurveyType,
} from './actions';

const EMPTY_OBJECT = {};

// ************
// PARTS
// ************
const reducerParts = {
	[clear]: state => {
		return {
			...state,
			selectedCustomers: EMPTY_OBJECT,
			selectedOwners: EMPTY_OBJECT,
			selectedEditors: EMPTY_OBJECT,
			selectedLineNames: EMPTY_OBJECT,
			selectedSurveyTypes: EMPTY_OBJECT,
		};
	},

	// ***********
	// CUSTOMERS
	// ***********

	[clearCustomers]: state => {
		return {
			...state,
			selectedCustomers: EMPTY_OBJECT,
		};
	},

	[addCustomer]: (state, { payload: { customer } = {}} = {}) => {
		const map = {...state.selectedCustomers };

		if (map[customer]) {
			return state;
		}

		map[customer] = true;
		return {
			...state,
			selectedCustomers: map,
		};
	},

	[removeCustomer]: (state, { payload: { customer } = {}} = {}) => {
		const map = {...state.selectedCustomers };

		if (!map[customer]) {
			return state;
		}

		delete map[customer];
		return {
			...state,
			selectedCustomers: map,
		};
	},

	// ***********
	// OWNERS
	// ***********

	[clearOwners]: state => {
		return {
			...state,
			selectedOwners: EMPTY_OBJECT,
		};
	},

	[addOwner]: (state, { payload: { owner } = {}} = {}) => {
		const map = {...state.selectedOwners };

		if (!owner?.compositeId || map[owner?.compositeId]) {
			return state;
		}

		map[owner.compositeId] = true;
		return {
			...state,
			selectedOwners: map,
		};
	},

	[removeOwner]: (state, { payload: { owner } = {}} = {}) => {
		const map = {...state.selectedOwners };

		if (!owner?.compositeId || !map[owner?.compositeId]) {
			return state;
		}

		delete map[owner.compositeId];
		return {
			...state,
			selectedOwners: map,
		};
	},


	// ***********
	// EDITED BY
	// ***********

	[clearEditors]: state => {
		return {
			...state,
			selectedEditors: EMPTY_OBJECT,
		};
	},

	[addEditor]: (state, { payload: { editedBy } = {}} = {}) => {
		const map = {...state.selectedEditors };

		if (!editedBy?.compositeId || map[editedBy?.compositeId]) {
			return state;
		}

		map[editedBy.compositeId] = true;
		return {
			...state,
			selectedEditors: map,
		};
	},

	[removeEditor]: (state, { payload: { editedBy } = {}} = {}) => {
		const map = {...state.selectedEditors };

		if (!editedBy?.compositeId || !map[editedBy?.compositeId]) {
			return state;
		}

		delete map[editedBy.compositeId];
		return {
			...state,
			selectedEditors: map,
		};
	},


	// ***********
	// LINE NAMES
	// ***********

	[clearLineNames]: state => {
		return {
			...state,
			selectedLineNames: EMPTY_OBJECT,
		};
	},

	[addLineName]: (state, { payload: { name: lineName } = {}} = {}) => {
		const map = {...state.selectedLineNames };

		if (map[lineName]) {
			return state;
		}

		map[lineName] = true;
		return {
			...state,
			selectedLineNames: map,
		};
	},

	[removeLineName]: (state, { payload: { name: lineName } = {}} = {}) => {
		const map = {...state.selectedLineNames };

		if (!map[lineName]) {
			return state;
		}

		delete map[lineName];
		return {
			...state,
			selectedLineNames: map,
		};
	},

	// ***********
	// SURVEY TYPES
	// ***********

	[clearSurveyTypes]: state => {
		return {
			...state,
			selectedSurveyTypes: EMPTY_OBJECT,
		};
	},

	[addSurveyType]: (state, { payload: { surveyType } = {}} = {}) => {
		const map = {...state.selectedSurveyTypes };

		if (map[surveyType]) {
			return state;
		}

		map[surveyType] = true;
		return {
			...state,
			selectedSurveyTypes: map,
		};
	},

	[removeSurveyType]: (state, { payload: { surveyType } = {}} = {}) => {
		const map = {...state.selectedSurveyTypes };

		if (!map[surveyType]) {
			return state;
		}

		delete map[surveyType];
		return {
			...state,
			selectedSurveyTypes: map,
		};
	},
};

export default reducerParts;
